/**
 * Permet de gérer les pauses
 * @type {string}
 */
export const SERVICE_BREAK_POST = 'postPause'
